/**
 * فهرستِ سایت‌های رقیب (مایگریشن 0134) — استثنای نشانِ لینک‌های خروجی.
 *
 * دو مصرف‌کننده دارد: هر دو اپ که موقعِ بوت `refresh()` را صدا می‌زنند تا
 * `core/lib/outboundUrl` فهرستِ واقعی را داشته باشد، و سربرگِ «سایت‌های
 * رقیب» در ادمین که با `list`/`add`/`remove` نگهش می‌دارد. نوشتن مثلِ بقیه‌ی
 * کارهای ادمین از RPCِ `security definer` می‌گذرد که خودش ادمین بودن را
 * چک می‌کند (نگاه کن به سرِ adminRepo.ts).
 */
import { supabase } from '../lib/supabase';
import { isDemoMode } from '../lib/demo';
import { DEFAULT_COMPETITOR_DOMAINS, setCompetitorDomains } from '../lib/outboundUrl';

export type CompetitorDomain = {
  domain: string;
  note: string;
  addedAt: string;
};

export const competitorRepo = {
  /** همه، به ترتیبِ الفبا — برای جدولِ ادمین. */
  async list(): Promise<CompetitorDomain[]> {
    if (isDemoMode) {
      return DEFAULT_COMPETITOR_DOMAINS.map((domain) => ({ domain, note: '', addedAt: '' }));
    }
    const { data, error } = await supabase
      .from('competitor_domains')
      .select('domain, note, added_at')
      .order('domain');
    if (error) throw error;
    return (data ?? []).map((r) => ({ domain: r.domain, note: r.note, addedAt: r.added_at }));
  },

  /**
   * فهرست را از دیتابیس در `outboundUrl` می‌نشاند — یک بار موقعِ بوتِ هر اپ.
   *
   * عمداً بی‌صداست: اگر شبکه نبود یا کوئری نرسید، فهرستِ سفت‌شده‌ی
   * `DEFAULT_COMPETITOR_DOMAINS` کار را ادامه می‌دهد و لینک‌ها نباید منتظرِ
   * این جواب بمانند.
   */
  async refresh(): Promise<void> {
    if (isDemoMode) return;
    try {
      const { data, error } = await supabase.from('competitor_domains').select('domain');
      if (error || !data) return;
      setCompetitorDomains(data.map((r) => r.domain));
    } catch {
      /* بدونِ شبکه هم لینک ساختن باید کار کند */
    }
  },

  /** افزودن/به‌روزکردن — فقط ادمین. نرمال‌سازیِ دامنه در خودِ RPC است. */
  async add(domain: string, note = ''): Promise<void> {
    if (isDemoMode) return;
    const { error } = await supabase.rpc('admin_add_competitor_domain', {
      p_domain: domain, p_note: note,
    });
    if (error) throw error;
  },

  /** حذف — فقط ادمین. */
  async remove(domain: string): Promise<void> {
    if (isDemoMode) return;
    const { error } = await supabase.rpc('admin_remove_competitor_domain', { p_domain: domain });
    if (error) throw error;
  },
};
